var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30c375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28ae67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de414f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca3745"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#p"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    fillRule: "evenodd",
    rx: 1.142857,
    ry: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v11.428571h-16z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.285714 0h2.285714v11.428571h-2.285714z",
    fill: "url(#d)",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(2.285714 .761905)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    rx: 1.142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#dd404f",
    mask: "url(#f)",
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbaf29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.142857v1h-1.142857z",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.142857.761905h1.142857v1h-1.142857z",
    mask: "url(#h)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(2.285714 9.142857)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fff",
    rx: 1.142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#dd404f",
    mask: "url(#i)",
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fbaf29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.142857v1h-1.142857z",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.142857.761905h1.142857v1h-1.142857z",
    mask: "url(#k)"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(2.285714 5.333333)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#28ae67",
    rx: 1.142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#dd404f",
    mask: "url(#l)",
    r: 1
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.285714 6.857143)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "p",
    cx: 1.142857,
    cy: 1.142857,
    fill: "#28ae67",
    fillRule: "nonzero",
    rx: 1.142857,
    ry: 1
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(2.285714 3.047619)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#fbaf29",
    rx: 1.142857,
    ry: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.142857,
    cy: 0.761905,
    fill: "#dd404f",
    mask: "url(#m)",
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#28ae67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1v1.52381h-1z",
    mask: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52381 0h1v1.52381h-1z",
    mask: "url(#o)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m8.47008716 2.42180407c-.13523878.1611713-.1142163.40145915.04695497.53669792.16117136.13523878.4014592.11421632.53669798-.04695498.13523879-.16117131.11421631-.40145915-.04695504-.53669793-.16117128-.13523878-.40145913-.11421632-.53669791.04695499zm-.98711158 1.47685454c-.16117131-.13523879-.40145915-.11421632-.53669793.04695498s-.11421632.40145915.04695499.53669792c.1611713.13523878.40145915.11421632.53669792-.04695498.13523881-.1611713.11421634-.40145914-.04695498-.53669792zm-.76190476-.76190477c-.16117131-.13523878-.40145915-.11421632-.53669793.04695499-.13523878.1611713-.11421632.40145915.04695499.53669792.1611713.13523878.40145914.11421632.53669792-.04695498.13523878-.16117131.11421632-.40145915-.04695498-.53669793zm1.52380948-1.52380952c-.16117127-.13523878-.40145912-.11421632-.5366979.04695499-.13523877.1611713-.1142163.40145914.04695497.53669792.16117135.13523878.4014592.11421632.53669798-.04695498.13523878-.16117131.11421631-.40145915-.04695505-.53669793zm-.38095238 1.14285714c-.16117127-.13523878-.4014591-.11421632-.53669789.04695499-.13523878.1611713-.11421632.40145915.04695499.53669792.1611713.13523878.40145917.11421632.53669795-.04695498.13523878-.16117131.11421631-.40145915-.04695505-.53669793z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.98634103 5.40029745c-.90745692.90745692-2.3787353.90745692-3.28619222 0-.08792997-.08792997-.16733978-.18115369-.23822943-.27864527.90864321.66070733 2.18801997.58129753 3.00754691-.23822942.81952701-.81952695.89893671-2.09890373.23822948-3.00754694.09749151.07088966.19071528.15029946.27864526.23822944.90745687.90745691.90745687 2.37873527 0 3.28619219z",
    fill: "url(#a)",
    fillRule: "nonzero",
    mask: "url(#e)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTm);
export default __webpack_public_path__ + "static/media/TM.e79c457bbb079dfd23d45ea55250cecc.svg";
export { ForwardRef as ReactComponent };